import React, { useEffect, useState, useMemo } from 'react';
import './_seo.scss';
import './_seo.dark-mode.scss';
import { Badge, ControlLabel, FormControl, Collapse, FormGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { getCurrentDomain } from '../../utils/helper';
import TagsInput from '../TagsInput';

const Seo = ({ title, keywords, description, languageCode, languageName, url, onChange }) => {
  const [isOpenCollapse, setOpenCollapse] = useState(false);
  const [seoData, setSeoData] = useState({
    title: title || '',
    keywords: keywords || '',
    description: description || '',
  })

  const domain = useMemo(() => getCurrentDomain(), []);

  const onChangeSeoData = (key, value) => {
    setSeoData((prevState) => ({
      ...prevState,
      [key]: value,
    }))
  }

  useEffect(() => {
    onChange(seoData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seoData])

  return (
    <div className="seo-block">
      <div className="seo-block__header">
        <div className="seo-block__header-title">
          <div>Search engine listing preview</div>
          {languageName ? <Badge>{languageName}</Badge> : null}
        </div>
        <div>
          <span
            onClick={() => setOpenCollapse(!isOpenCollapse)}
            className="seo-block__header-collapse"
          >
            Edit page SEO
          </span>
        </div>
      </div>
      <div className="seo-block__preview">
        <div className="seo-block__preview-title">{seoData.title}</div>
        <div className="seo-block__preview-url">
          {domain}
          {languageCode ? `/${languageCode}` : null}
          {url && url !== '/' ? `/${url}` : null}
        </div>
        <div className="seo-block__preview-description">{seoData.description}</div>
      </div>
      <Collapse in={isOpenCollapse}>
        <div>
          <FormGroup>
            <ControlLabel htmlFor="title">
              Page title
            </ControlLabel>
            <FormControl
              type="text"
              id="title"
              name="title"
              value={seoData.title}
              onChange={(e) => onChangeSeoData('title', e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <ControlLabel htmlFor="keywords">
              Meta-keywords
            </ControlLabel>
            <TagsInput
              value={seoData.keywords}
              onChange={(value) => onChangeSeoData('keywords', value)}
            />
          </FormGroup>
          <FormGroup>
            <ControlLabel htmlFor="description">
              Meta-description
            </ControlLabel>
            <FormControl
              componentClass="textarea"
              id="description"
              name="description"
              rows={5}
              value={seoData.description}
              onChange={(e) => onChangeSeoData('description', e.target.value)}
            />
          </FormGroup>
        </div>
      </Collapse>
    </div>
  )
};

Seo.defaultProps = {

};

Seo.propTypes = {
  title: PropTypes.string,
  keywords: PropTypes.string,
  description: PropTypes.string,
  languageCode: PropTypes.string,
  languageName: PropTypes.string,
  url: PropTypes.string,
  onChange: PropTypes.func,
};

export default Seo;
